import { FavouriteConditionValue } from 'app/types-shared';
import { createInitialDefaultValue } from 'app/components/filters/filters-panel/filter-types/create-initial-default-value';
import { configuration } from 'app/components/filters/filters-panel/filter-types/configuration';

export const mapInitialConditionsValues = (
  conditionValues: FavouriteConditionValue[],
  advancedSearchType: number,
  favouriteConditionValue: FavouriteConditionValue
) => {

  const mapping = configuration
    .map(item => item.initialValue)
    .filter(item => !!item && item)
    .reduce((result, initialValue) => ({
      ...result,
      ...initialValue(favouriteConditionValue, conditionValues)
    }), {});

  return mapping[advancedSearchType] || createInitialDefaultValue(favouriteConditionValue, conditionValues, advancedSearchType);
};
